export default class HeaderField {
  constructor(public text: string, public value: string) {}
}
